import { DebounceSettings } from 'lodash'
import debounce from 'lodash/debounce'

const debouncedFunctions = new Map<string, ReturnType<typeof debounce>>()

function getKeyFromArgs(args: unknown[]): string {
  return JSON.stringify(args)
}

export function debounceWithArgs<T extends (...args: any[]) => any>(
  fn: T,
  wait: number,
  options?: DebounceSettings
): (...args: Parameters<T>) => any {
  return function (...args: Parameters<T>) {
    const key = getKeyFromArgs(args)
    if (!debouncedFunctions.has(key)) {
      debouncedFunctions.set(
        key,
        debounce(() => fn(...args), wait, options)
      )
    }

    return debouncedFunctions.get(key)!()
  }
}
